import { SVGProps } from 'react';

const SvgUserRounded = (props: SVGProps<SVGSVGElement>) => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="15" cy="7.5" r="5" stroke="#2196F3" strokeWidth="1.5" />
    <ellipse cx="15" cy="21.25" rx="8.75" ry="5" stroke="#2196F3" strokeWidth="1.5" />
  </svg>
);
export default SvgUserRounded;
